(function () {
  function readJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function applyTemplate(template, values) {
    return Object.keys(values).reduce(function (result, key) {
      return result
        .split("{{ " + key + " }}").join(values[key])
        .split("{{" + key + "}}").join(values[key]);
    }, template || "");
  }

  function resultText(diff, strings) {
    if (diff > 0) {
      return applyTemplate(strings.room, { amount: Math.abs(diff) });
    }
    if (diff < 0) {
      return applyTemplate(strings.close, { amount: Math.abs(diff) });
    }
    return strings.same;
  }

  function setPressed(buttons, selected) {
    buttons.forEach(function (button) {
      button.setAttribute("aria-pressed", String(button === selected));
    });
  }

  function updateFitTool(tool, sizeKey) {
    var config = readJson(tool.querySelector("[data-fit-config]"));
    if (!config || !config.sizes[sizeKey]) return;

    var size = config.sizes[sizeKey];
    var bust = config.garment.bust - size.bust;
    var waist = config.garment.waist - size.waist;
    var hip = config.garment.hip - size.hip;
    var summary = tool.querySelector("[data-fit-summary]");

    if (summary) {
      summary.textContent = applyTemplate(config.strings.summary, {
        size: sizeKey,
        bust: bust,
        waist: waist,
        hip: hip
      });
    }

    ["bust", "waist", "hip"].forEach(function (key) {
      var node = tool.querySelector('[data-fit-result="' + key + '"]');
      if (!node) return;
      node.textContent = resultText(config.garment[key] - size[key], config.strings);
    });
  }

  function initFitTool(tool) {
    var buttons = Array.prototype.slice.call(tool.querySelectorAll("[data-size-choice]"));
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        setPressed(buttons, button);
        updateFitTool(tool, button.dataset.sizeChoice);
      });
    });

    var selected = buttons.find(function (button) {
      return button.getAttribute("aria-pressed") === "true";
    }) || buttons[0];
    setPressed(buttons, selected);
    updateFitTool(tool, selected.dataset.sizeChoice);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-fit-tool]").forEach(initFitTool);
  });
})();
function cleanGeneratedPolicyCopy(replacements) {
  if (!window.location.pathname.includes('/policies/')) return;

  const main = document.querySelector('main');
  if (!main) return;

  const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach((node) => {
    let value = node.nodeValue;
    replacements.forEach(([from, to]) => { value = value.split(from).join(to); });
    node.nodeValue = value;
  });

  main.querySelectorAll('a[href]').forEach((link) => {
    let href = link.getAttribute('href');
    replacements.forEach(([from, to]) => { href = href.split(from).join(to); });
    link.setAttribute('href', href);
  });
}

cleanGeneratedPolicyCopy([
  ['fashion', 'Gallery Saf'],
  ['Fashion', 'Gallery Saf'],
  ['Atelier Saf', 'Gallery Saf'],
  ['fit@example.com', 'info@pyranext.com'],
  ['warherome@gmail.com', 'info@pyranext.com'],
  ['+20 100 000 0000', 'info@pyranext.com']
]);
